import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Your Staking Account", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "inline-block bg-yellow-200" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "flex mb-5" }
const _hoisted_11 = { class: "flex-1 mr-5" }
const _hoisted_12 = { class: "flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" state: "),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.parseFarmerState(_ctx.farmerAcc)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, "Your identity: " + _toDisplayString(_ctx.farmerAcc.identity.toBase58()), 1),
    _createElementVNode("div", _hoisted_6, "Associated vault: " + _toDisplayString(_ctx.farmerAcc.vault.toBase58()), 1),
    _createElementVNode("div", _hoisted_7, "Gems staked: " + _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
    _createElementVNode("div", _hoisted_8, " Min staking ends: " + _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.minStakingEndsTs)), 1),
    _createElementVNode("div", _hoisted_9, " Cooldown ends: " + _toDisplayString(_ctx.parseDate(_ctx.farmerAcc.cooldownEndsTs)), 1),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createBlock(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc.rewardA,
          farmReward: _ctx.farmAcc.rewardA,
          reward: _ctx.farmerAcc.rewardA,
          title: "Reward A"
        }, null, 8, ["farmReward", "reward"]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createBlock(_component_FarmerRewardDisplay, {
          key: _ctx.farmerAcc.rewardB,
          farmReward: _ctx.farmAcc.rewardB,
          reward: _ctx.farmerAcc.rewardB,
          title: "Reward B"
        }, null, 8, ["farmReward", "reward"]))
      ])
    ]),
    _createElementVNode("button", {
      class: "nes-btn is-primary mb-5",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshFarmer && _ctx.refreshFarmer(...args)))
    }, " Refresh account ")
  ]))
}